var exports = {
  "pq": "UserIdentityRow.module__info___Q1VGem",
  "UU": "UserIdentityRow.module__name___Q1VGem",
  "Tc": "UserIdentityRow.module__tag___Q1VGem",
};

module.exports = exports;
